import { Axios } from "../../../util";
import axios from "axios";

const searchRegisterHistoryAPI = async (payload) => {
  try {
    const res = await Axios.post('/api/request/getRegisterHistory',payload);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};


export { searchRegisterHistoryAPI
        };
